import React from 'react';
import LoginForm from '../../components/shared/LoginForm';

const ResellerLoginPage: React.FC = () => {
  return <LoginForm mode="reseller" />;
};

export default ResellerLoginPage;
